<template>
  <!-- Side Nav START -->
  <div class="side-nav">
    <div class="side-nav-inner">
      <ul class="side-nav-menu scrollable mt-1">
        <li class="nav-item dropdown open">
          <router-link class="dropdown-toggle" :to="`/`">
            <span class="icon-holder">
              <i class="fa fa-home" aria-hidden="true"></i>
            </span>
            <span class="title">Dashboard</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/accounts`">
            <span class="icon-holder">
              <i class="fa fa-files-o"></i>
            </span>
            <span class="title">Accounts</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/downloads`">
            <span class="icon-holder">
              <i class="fa fa-download"></i>
            </span>
            <span class="title">Downloads</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/categories`">
            <span class="icon-holder">
              <i class="fa fa-list-alt"></i>
            </span>
            <span class="title">Category</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/products`">
            <span class="icon-holder">
              <i class="fa fa-shopping-bag"></i>
            </span>
            <span class="title">Products</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/photos`">
            <span class="icon-holder">
              <i class="fa fa-images"></i>
            </span>
            <span class="title">Photos</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/branding-and-logo`">
            <span class="icon-holder">
              <i class="fa fa-list-alt"></i>
            </span>
            <span class="title">Branding & Logos</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/presentation-materials`">
            <span class="icon-holder">
              <i class="fas fa-file-powerpoint"></i>
            </span>
            <span class="title">Presentation Materials</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/advertisements`">
            <span class="icon-holder">
              <i class="fas fa-ad"></i>
            </span>
            <span class="title">Advertisements</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/sell-sheet-categories`">
            <span class="icon-holder">
              <i class="fas fa-file-excel"></i>
            </span>
            <span class="title">Sell Sheets Categories</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/sell-sheets`">
            <span class="icon-holder">
              <i class="fas fa-file-excel"></i>
            </span>
            <span class="title">Sell Sheets</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/public-relations`">
            <span class="icon-holder">
              <i class="fas fa-users"></i>
            </span>
            <span class="title">Public Relations</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/videos`">
            <span class="icon-holder">
              <i class="fas fa-video"></i>
            </span>
            <span class="title">Videos</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/1868-categories`">
            <span class="icon-holder">
              <i class="fas fa-file-excel"></i>
            </span>
            <span class="title">1868 Categories</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/1868s`">
            <span class="icon-holder">
              <i class="fas fa-video"></i>
            </span>
            <span class="title">1868s</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/helps`">
            <span class="icon-holder">
              <i class="fa fa-question-circle" aria-hidden="true"></i>
            </span>
            <span class="title">User Queries</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
  <!-- Side Nav END -->
</template>

<script>
export default {
  name: 'Sidebar',
  data () {
    return {}
  },
  mounted () {
    /* eslint-disable no-undef */
    const appLayout = $('#app')
    $('.side-nav-inner .side-nav-menu .nav-item').on('click', () => {
      appLayout.removeClass('is-expand')
    })
  },
  methods: {}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue